module.exports = __webpack_public_path__ + "media/images/logo-61bb47a6954edabc5d5797bfb6d97dd6.png";